import { useState, useEffect, useContext, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import SuiBox from "components/SuiBox";

import toast from "react-hot-toast";
import api from "services/api";
import moment from "moment";
import qs from "query-string";

import { BackTop } from "antd";

import CollectionCard from "components/UpStyled/CollectionCard";
import StyleCard2 from "components/UpStyled/StyleCard2";
import MoodboardCard2 from "pages/de/collection/moodboards/components/MoodboardCard2";
import RecentWorkCard from "pages/create/components/RecentWorkCard";

import SharedContentContext from "context/shared-content";
import { compare } from "utils/helper";
import { Empty } from "antd";
import DataTable from "examples/Tables/DataTable";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import Card from "@mui/material/Card";

const avatarSize = 26;

const RecentShares = ({ width, height, size = 60, sx = {} }) => {
  const [styleList, setStyleList] = useState([]);
  const [moodboards, setMoodboards] = useState([]);
  const [collectionList, setCollectionList] = useState([]);

  const { resourceList, fullMap, retrieveContentPermission } = useContext(SharedContentContext);

  useEffect(() => {
    retrieveContentPermission();
    retrieveStyles();
    retrieveMoodboards();
    retrieveCollections();
  }, []);

  const retrieveStyles = async () => {
    try {
      const { data } = await api.products.sharedList();

      let myProducts = data?.products || [];
      myProducts = myProducts.map((x) => ({
        ...x,
        shared_at: fullMap?.[x.id]?.updated_at || fullMap?.[x.id]?.created_at,
        displayType: "style",
      }));
      myProducts = myProducts.sort((a, b) => compare(a, b, "-shared_at"));

      setStyleList(myProducts || []);
    } catch (err) {
      toast.error(`Retrieve style list failed`);
      console.log(err);
    }
  };

  const retrieveMoodboards = async () => {
    try {
      const { data } = await api.moodboard.sharedList();
      let myMoodboard = data?.moodboards || [];
      myMoodboard = myMoodboard.map((x) => ({
        ...x,
        shared_at: fullMap?.[x.id]?.updated_at || fullMap?.[x.id]?.created_at,
        displayType: "moodboard",
      }));
      myMoodboard = myMoodboard.sort((a, b) => compare(a, b, "-shared_at"));

      setMoodboards(myMoodboard);
    } catch (err) {
      toast.error(`Retrieve moodboards failed!`);
      console.log(err);
    }
  };

  const retrieveCollections = async () => {
    try {
      const { data } = await api.collections.sharedList();

      let myCollections = data?.collections || [];

      myCollections = myCollections.map((x) => ({
        ...x,
        shared_at: fullMap?.[x.id]?.updated_at || fullMap?.[x.id]?.created_at,
        displayType: "collection",
      }));
      myCollections = myCollections.sort((a, b) => compare(a, b, "-shared_at"));

      setCollectionList(myCollections || []);
    } catch (err) {
      toast.error(`Retrieve collection list failed`);
      console.log(err);
    }
  };

  const recentShares = [...moodboards, ...collectionList, ...styleList].sort((a, b) =>
    compare(a, b, "-shared_at")
  );
  const getMoodboardRow = (item) => {
    let resource = resourceList.find((x) => x.resource_id == item.id) || {};
    const owner = item.owner || {};
    const storeInfo = owner?.stores?.[0] || {};

    return {
      key: item.id,
      image: item?.img,
      name: item.name || item.title,
      updated_at: item.updated_at,
      shared_at: resource?.created_at,
      owner: storeInfo,
      ownerName: storeInfo?.name,
    };
  };
  const columns = [
    {
      Header: "Image",
      accessor: "image",
      align: "center",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => {
        return (
          <Link to={`/shared-with-me/moodboards?id=${row?.original?.key}`}>
            <ImageCardWrapper data={value} mode={"normal"} height={size} width={size} iconMode />
          </Link>
        );
      },
    },
    {
      Header: "Name",
      accessor: "name",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => {
        return <div style={{ maxWidth: 400 }}>{value}</div>;
      },
    },
    {
      Header: "Updated Date",
      accessor: "updated_at",
      resizable: true,
      Cell: ({ row, value }) => {
        return (
          <Tooltip title={value ? moment(value).format("MM/DD/YY HH:mm:ss") : ""}>
            <div>{value ? moment(value).format("MM/DD/YY") : ""}</div>
          </Tooltip>
        );
      },
    },
    {
      Header: "Shared Date",
      accessor: "shared_at",
      Cell: ({ row, value }) => {
        return (
          <Tooltip title={value ? moment(value).format("MM/DD/YY HH:mm:ss") : ""}>
            <div>{value ? moment(value).format("MM/DD/YY") : ""}</div>
          </Tooltip>
        );
      },
    },
    {
      Header: "Owner",
      accessor: "ownerName",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => {
        return (
          <SuiBox
            display="flex"
            alignItems="center"
            justifyContent="center"
            color="inherit"
            sx={{ cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
              if (row.original?.owner?.id) {
                account?.id
                  ? navigate(`/wall/portfolio/${row.original?.owner?.id}`)
                  : navigate(`/public/portfolio/${row.original?.owner?.id}`);
              }
            }}
          >
            <Avatar
              src={row.original?.owner?.metadata?.avatar}
              sx={{ width: avatarSize, height: avatarSize, mr: 0.5 }}
            />
            {value}
          </SuiBox>
        );
      },
    },
  ];
  const moodboardRows = recentShares.map((item) => getMoodboardRow(item));

  return (
    <Card sx={sx}>
      <div>
        <SuiBox
          display="flex"
          alignItems="center"
          justifyContent="flex-start"
          gap={2}
          sx={{ overflow: "auto" }}
        >
          {recentShares.length > 0 ? (
            <DataTable
              table={{ columns: columns, rows: moodboardRows }}
              entriesPerPage={{ defaultValue: 10 }}
              showTotalEntries={true}
              pagination={true}
              canSearch
            />
          ) : (
            <div style={{ width: "100%" }}>
              <Empty description={null} />
            </div>
          )}
        </SuiBox>
      </div>

      <BackTop />
    </Card>
  );
};

export default RecentShares;
